<template>
  <div class="location-coverage-bar">
    <h2 class="global-h4 location-coverage-bar__title">Promotion coverage</h2>
    <p class="location-coverage-bar__subtitle">{{ highlighted }} of {{ total }} locations have been highlighted</p>

    <div class="location-coverage-bar__track">
      <div v-if="total > 0" class="location-coverage-bar__fill location-coverage-bar__fill--highlighted" :style="{ width: `${highlightedPercent}%` }"></div>
      <div v-if="total > 0" class="location-coverage-bar__fill location-coverage-bar__fill--not-yet" :style="{ width: `${100 - highlightedPercent}%` }"></div>
    </div>

    <div class="location-coverage-bar__legend">
      <span class="location-coverage-bar__legend-item">
        <span class="location-coverage-bar__dot location-coverage-bar__dot--highlighted"></span>
        Highlighted {{ highlighted }}
      </span>
      <span class="location-coverage-bar__legend-item">
        <span class="location-coverage-bar__dot location-coverage-bar__dot--not-yet"></span>
        Not yet highlighted {{ notYetCount }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  highlightedCount: number;
  totalCount: number;
}>();

const total = computed<number>(() => Math.max(0, props.totalCount));
const highlighted = computed<number>(() => Math.max(0, Math.min(props.highlightedCount, total.value)));
const notYetCount = computed<number>(() => total.value - highlighted.value);
const highlightedPercent = computed<number>(() => (total.value === 0 ? 0 : (100 * highlighted.value) / total.value));
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

// Location coverage bar ======================================================
.location-coverage-bar {
  height: 100%;
  box-sizing: border-box;
  padding: 22px 24px;
  border: 1px solid #e4e7ec;
  border-radius: 11px;
  background: #fff;

  &__title {
    margin: 0 0 4px;
  }

  &__subtitle {
    margin: 0 0 18px;
    color: #667085;
    font: 400 14px/18px sans-serif;
  }

  &__track {
    width: 100%;
    height: 14px;
    display: flex;
    border-radius: 100px;
    overflow: hidden;
    background: #e4e7ec;
  }

  &__fill {
    height: 100%;
    transition: width 0.2s ease-in-out;

    &--highlighted {
      background: #058587;
    }

    &--not-yet {
      background: #f2b84b;
    }
  }

  &__legend {
    margin-top: 14px;
    gap: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: #667085;
    font: 400 14px/18px sans-serif;
  }

  &__legend-item {
    display: inline-flex;
    align-items: center;
  }

  &__dot {
    width: 9px;
    height: 9px;
    margin-right: 7px;
    border-radius: 100px;

    &--highlighted {
      background: #058587;
    }

    &--not-yet {
      background: #f2b84b;
    }
  }
}
</style>
